import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    folderId: String,
    folderTitle: String,
    modalId: String,
  }

  open(event) {
    event.preventDefault()

    this.dispatch(
      'show',
      {
        detail: {
          folderId: this.folderIdValue,
          folderTitle: this.folderTitleValue,
          modalId: this.modalIdValue,
        },
      },
    )
  }
}
